import React, { forwardRef, useRef, useImperativeHandle } from 'react';
import { Input } from '../../ui/input';

const StableInput = forwardRef(({ 
  id, 
  value, 
  onChange, 
  placeholder,
  className = "w-full",
  readonly = false
}, ref) => {
  const inputRef = useRef(null);
  
  useImperativeHandle(ref, () => ({
    focus: () => inputRef.current?.focus(),
    blur: () => inputRef.current?.blur(),
    select: () => inputRef.current?.select()
  }));

  const handleChange = (e) => {
    if (onChange) {
      onChange(e.target.value);
    }
  };

  return (
    <Input
      ref={inputRef}
      id={id}
      type="text"
      value={value || ''}
      onChange={handleChange}
      placeholder={placeholder}
      className={className}
      readOnly={readonly}
    />
  );
});

StableInput.displayName = 'StableInput';

export default React.memo(StableInput);
